// extracted by mini-css-extract-plugin
export default {"container":"Clock_container__x-xKO","unitBlock":"Clock_unitBlock__336bc","unitSeperator":"Clock_unitSeperator__hLKBz"};